import { render, staticRenderFns } from "./FixedBearingsEdgeContact.vue?vue&type=template&id=88532360&scoped=true"
import script from "./FixedBearingsEdgeContact.vue?vue&type=script&lang=js"
export * from "./FixedBearingsEdgeContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88532360",
  null
  
)

export default component.exports